import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	getYearlyUtilisationReport,
} from "~/modules/reports/api/utilisationReport/utilisationReportApiDispatchers.ts";

export const UTILISATION_REPORT_BASE_QUERY_KEY = "utilisation-report";

export const utilisationReportQueries = {
	baseKey: [UTILISATION_REPORT_BASE_QUERY_KEY],
	byYear: (year: string) => queryOptions({
		queryKey: [...utilisationReportQueries.baseKey, year],
		queryFn: () => getYearlyUtilisationReport(year).then(getDataFromResponse),
	}),
};